export default {
  menu: [
    {
      id: 'basic',
      title: 'Principal',
      icon: 'home',
      iconType: 'fa',
      iconStyle: 'light',
      class: '',
      route: 'integra.porto-remocao.main'
    },
    {
      id: 'salvados',
      title: 'Salvados em Remoção',
      icon: 'truck-ramp-box',
      iconType: 'fa',
      iconStyle: 'light',
      class: '',
      route: 'integra.porto-remocao.salvados'
    }
  ]
}
